/**
 * @module app.config.color
 */
import {TRACK_COLOR_VALUES} from "../constants";

class Controller {
  constructor() {
    /**
     * @type {function(appx.ColorChangeEvent)}
     * @export
     */
    this.onChange;
  }

  /**
   * @export
   */
  colors() {
    return TRACK_COLOR_VALUES;
  }

  /**
   * @export
   * @param {TRACK_COLOR} color
   */
  setColor(color) {
    const colorRgb = TRACK_COLOR_VALUES[color].color;
    this.onChange({color, colorRgb});
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'color': '<',
    'labelText': '@',
    'onChange': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/config/color/partial.html'
};

export default angular.module('appConfigColorComponent', []).component('appConfigColor', component);
